export default __webpack_public_path__ + "static/media/clear2.42d27630.mp3";